
      var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAlert = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 48,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#alert_f0c8c49ae02b9f74__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.675 2.532c.205.119.376.29.494.495l5.163 8.948A1.35 1.35 0 0 1 13.162 14H2.838a1.35 1.35 0 0 1-1.17-2.025l5.164-8.948a1.35 1.35 0 0 1 1.844-.495zM8 10.36a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm.028-5.5a1 1 0 0 0-1 1v2.5a1 1 0 0 0 2 0v-2.5a1 1 0 0 0-1-1z",
  fill: "var(--theme-primary, #810ea9)"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "alert_f0c8c49ae02b9f74__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-light, #f9f3fb)",
  transform: "translate(1 2)",
  d: "M0 0h14v12H0z"
})))));

      const __svgRaw = "<svg width=\"48\" height=\"48\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <g clip-path=\"url(#jugvzwu7ca)\">\r\n        <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.675 2.532c.205.119.376.29.494.495l5.163 8.948A1.35 1.35 0 0 1 13.162 14H2.838a1.35 1.35 0 0 1-1.17-2.025l5.164-8.948a1.35 1.35 0 0 1 1.844-.495zM8 10.36a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm.028-5.5a1 1 0 0 0-1 1v2.5a1 1 0 0 0 2 0v-2.5a1 1 0 0 0-1-1z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n    </g>\r\n    <defs>\r\n        <clipPath id=\"jugvzwu7ca\">\r\n            <path fill=\"var(--theme-light, #f9f3fb)\" transform=\"translate(1 2)\" d=\"M0 0h14v12H0z\"/>\r\n        </clipPath>\r\n    </defs>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/alert.f0c8c49ae02b9f74f6b7304c05e0ef6a.svg"),
        {
          React: SvgAlert,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      